<template>
  <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="1" />
    <div class="yj-banner rel">
      <img src="@/assets/images/yj-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/yinxiang/index" class="f16 fw">印象富林</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">印象富林</div>
        <div class="f17 ls3">Impressions of Guangfulin</div>
      </div>
    </div>
    <div class="spot-cont mt-40 pb50">
      <div class="spot-tit df align_center justify_center">
        <h2 class="f32 foo pb15">富林景点</h2>
      </div>
      <div class="spot-item df flex_wrap w1600 auto pt20">
        <div class="spot-box wp25" v-for="item in list" :key="item.Id">
          <router-link :to="'/pages/yinxiang/spot-view?id=' + item.Id" class="db rel ml12 mr12 mt24 spot-link">
            <img v-if="item.Photo" :src="item.Photo + '!/both/752x1002'" class="db wp100" alt="">
            <div class="spot-box-text df align_center justify_center">
              <span class="fw f18 spot-box-text-name" v-if="item.Name">{{ item.Name }}</span>
            </div>
          </router-link>
        </div>
      </div>
      <div class="pages df align_center justify_center pt50 pb50">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="filter.total"
          :current-page="filter.Page"
          :page-size="filter.PageSize"
          @current-change="handleCurrentPage">
        </el-pagination>
      </div>
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import scenicService from '@/services/client/cont/scenic'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      filter: {
        Page: 1,
        PageSize: 12,
        total: 0,
        Type: 1,
      },
      list: null,
    }
  },
  components: { Header, Bottom,},
  mounted() {
    this.loadData();
  },
  methods:{
    loadData() {
      this.list = null;
      scenicService.list(this.filter).then(res => {
        if(res.Code == 200 && res.Data && res.Data.List && res.Data.List.length > 0) {
          const data = res.Data;
          this.list = data.List;
          this.filter.total = data.Count;
        }
      })
    },
    handleCurrentPage(page) {
      this.filter.Page = page;
      this.loadData();
    }
  },

}
</script>



// WEBPACK FOOTER //
// src/views/yinxiang/spot.vue